import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';
// import { colors } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from '@remix-run/react';

const Features = (): JSX.Element => {
	let { t } = useTranslation(['workflows']);

	const { userLanguage } = useLoaderData();
	const link_prefix = userLanguage === 'en' ? '/en' : '';

	const mock = [
		{
			title: t('featues_mock_title_1'),
			subtitle: t('featues_mock_subtitle_1'),
			link: 'datenerhebung',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					height={30}
					width={30}
					fill='currentColor'
					stroke='currentColor'
					viewBox='0 96 960 960'
				>
					<path d='m459 753-43-43 103-103H80v-60h439L416 444l43-43 176 176-176 176ZM80 896V667h60v169h680V316H140v171H80V256h800v640H80Z' />
				</svg>
			),
		},

		{
			title: t('featues_mock_title_2'),
			subtitle: t('featues_mock_subtitle_2'),
			link: 'datenspeicherung',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					height={30}
					width={30}
					fill='currentColor'
					stroke='currentColor'
					viewBox='0 96 960 960'
				>
					{/* <path d='M167 896v-60h130q-64-48-100.5-108.5T160 579q0-100 59-186.5T387 272v62q-71 26-119 93t-48 152q0 64 27.5 117.5T337 790V666h60v230H167Zm433 0q-50 0-85-35t-35-85q0-48 33-83t81-37q17-36 50.5-58t75.5-22q53 0 91.5 34.5T858 696h2q42 0 71 30t29 69q0 42-29 71.5T860 896H600Zm136-360q-11-51-38-93.5T626 362v124h-60V256h230v60H665q49 41 86.5 100.5T797 536h-61ZM600 836h260q17 0 28.5-11.5T900 796q0-17-11.5-28.5T860 756h-50v-30q0-38-26-64t-64-26q-38 0-64 24.5T630 716h-30q-25 0-42.5 17.5T540 776q0 25 17.5 42.5T600 836Zm120-100Z' /> */}
					<path d='M140 796h680V516H140v280Zm540.118-90Q701 706 715.5 691.382q14.5-14.617 14.5-35.5Q730 635 715.382 620.5q-14.617-14.5-35.5-14.5Q659 606 644.5 620.618q-14.5 14.617-14.5 35.5Q630 677 644.618 691.5q14.617 14.5 35.5 14.5ZM880 456h-85L695 356H265L165 456H80l160-160h480l160 160ZM80 856V456h800v400H80Z' />{' '}
				</svg>
			),
		},
		{
			title: t('featues_mock_title_3'),
			subtitle: t('featues_mock_subtitle_3'),
			link: 'datenverarbeitung',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					height={30}
					width={30}
					fill='currentColor'
					stroke='currentColor'
					viewBox='0 96 960 960'
				>
					<path d='M604 936V811H450V401h-93v130H80V216h277v125h247V216h276v315H604V401h-94v350h94V621h276v315H604ZM140 276v195-195Zm524 405v195-195Zm0-405v195-195Zm0 195h156V276H664v195Zm0 405h156V681H664v195ZM140 471h157V276H140v195Z' />
				</svg>
			),
		},
		{
			title: t('featues_mock_title_4'),
			subtitle: t('featues_mock_subtitle_4'),
			link: 'datenanalyse',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					height={30}
					width={30}
					fill='currentColor'
					stroke='currentColor'
					viewBox='0 96 960 960'
				>
					<path d='M620 526h40v-50h60v-40h-60v-50h-40v140Zm-380-50h320v-40H240v40Zm60 210h40V546h-40v50h-60v40h60v50Zm100-50h320v-40H400v40Zm-70 300v-80H80V216h800v640H630v80H330ZM140 796h680V276H140v520Zm0-520v520-520Z' />
				</svg>
			),
		},
	];

	const theme = useTheme();

	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
		defaultMatches: true,
	});

	const LeftSide = () => (
		<Grid container spacing={4}>
			{mock.map((item, index) => (
				<Grid
					item
					xs={12}
					sm={6}
					key={index}
					// data-aos='fade-up' data-aos-delay={index * 100} data-aos-offset={100} data-aos-duration={600}
				>
					<Box
						display={'block'}
						width={1}
						sx={{
							transform: index % 2 === 1 ? { md: 'translateY(60px)' } : 'none',
						}}
					>
						<Box boxShadow={0} component={Card} padding={isMd ? 4 : 2} width={1}>
							<Box display={'flex'} flexDirection={'column'}>
								<Box
									component={Avatar}
									width={60}
									height={60}
									marginBottom={2}
									color={theme.palette.primary.dark}
									bgcolor={alpha(theme.palette.primary.light, 1)}
									borderRadius={0}
									alt='Unser Angebot an Prozessdigitalisierung'
									// onClick={(e) => {
									// 	e.preventDefault();

									// 	Scroll.scroller.scrollTo(item.link, {
									// 		duration: 2000,

									// 		smooth: true,

									// 		offset: -40,
									// 	});
									// }}
									// sx={{
									// 	cursor: 'pointer',
									// 	transition: 'all 0.25s ',
									// 	':hover': {
									// 		backgroundColor: theme.palette.primary.light,
									// 	},
									// 	'& svg': {
									// 		fill: theme.palette.primary.main,
									// 		transition: 'all 0.25s ',
									// 	},
									// 	':hover svg': {
									// 		fill: theme.palette.alternate.main,
									// 	},
									// }}
								>
									{item.icon}
								</Box>
								<Typography variant={'h6'} component={'h2'} gutterBottom sx={{ fontWeight: 700 }}>
									{item.title}
								</Typography>
								<Typography color='text.secondary'>{item.subtitle}</Typography>
								<Box sx={{ flexGrow: 1 }} />
								<Box marginTop={0} display={'flex'} justifyContent={'flex-end'}></Box>
							</Box>
						</Box>
					</Box>
				</Grid>
			))}
		</Grid>
	);

	const RightSide = () => (
		<Box marginLeft={isMd ? 15 : 0}>
			{/* <Box marginBottom={2}>
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: "medium",
          }}
          gutterBottom
          color={"primary"}
        >
          Nahtlose Integrationen
        </Typography>
      </Box> */}
			<Box marginBottom={isMd ? 4 : 4} marginTop={isMd ? 4 : 5}>
				<Typography component={'h3'} variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
					{t('features_headline')}
				</Typography>
				{/* <Typography color='text.secondary' variant={'subtitle1'}>
					{t('features_subheadline')}
				</Typography> */}
			</Box>
			<Grid container spacing={1}>
				{[
					t('features_list_1'),
					t('features_list_2'),
					t('features_list_13'),
					t('features_list_3'),
					t('features_list_5'),
					t('features_list_6'),
					t('features_list_7'),
					t('features_list_8'),
					t('features_list_9'),

					// t('features_list_10'),
					// t('features_list_11'),
					t('features_list_4'),

					t('features_list_12'),
				].map((item, i) => (
					<Grid item xs={12} key={i}>
						<Box component={ListItem} disableGutters width={'auto'} padding={0}>
							<Box component={ListItemAvatar} minWidth={'auto !important'} marginRight={2}>
								<Box
									component={Avatar}
									bgcolor={theme.palette.secondary.main}
									width={20}
									height={20}
								>
									<svg
										width={12}
										height={12}
										xmlns='http://www.w3.org/2000/svg'
										viewBox='0 0 20 20'
										fill='currentColor'
									>
										<path
											fillRule='evenodd'
											d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
											clipRule='evenodd'
										/>
									</svg>
								</Box>
							</Box>
							<ListItemText primary={item} />
						</Box>
					</Grid>
				))}
			</Grid>
			<Box marginTop={3}>
				<Typography component='p' variant='caption' color='text.secondary' fontWeight=''>
					{t('process_info')}
				</Typography>

				{/* <Link
					to={link_prefix + '/hire-us/'}
					prefetch='intent'
					style={{
						textDecoration: 'none',
					}}
					onClick={(e) => {
						e.stopPropagation();
						// e.preventDefault();
					}}
				>
					<Button
            component={"div"}
            size={"medium"}
            variant={"contained"}
            color={theme.palette.mode === "light" ? "primary" : "primary"}
            endIcon={
              <Box component={"svg"} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' fill='currentColor' stroke='currentColor' width={24} height={24}>
                <path d='m28.05 35.9-2.15-2.1 8.4-8.4H8v-3h26.3l-8.45-8.45 2.15-2.1L40.05 23.9Z' />
              </Box>
            }
          >
            Jetzt starten
          </Button>
				</Link> */}
			</Box>
		</Box>
	);

	return (
		<Grid container spacing={4}>
			<Grid item xs={12} md={6} order={{ xs: 1, md: 0 }}>
				<LeftSide />
			</Grid>
			<Grid item container alignItems={'center'} xs={12} md={6} order={{ xs: 0, md: 1 }}>
				<RightSide />
			</Grid>
		</Grid>
	);
};

export default Features;
